/* ══════════════════════════════════════════════════════
   Scaleify × Stripe Animations — v6
   Extracted from approved preview.html
   ══════════════════════════════════════════════════════ */

// ── CARD LINKS: Strip → arrows, wrap text for gradient underline ──
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.card-link').forEach(function(el) {
      var text = el.textContent.replace(/\s*→\s*$/, '').trim();
      el.textContent = '';
      var span = document.createElement('span');
      span.className = 'card-link-text';
      span.textContent = text;
      el.appendChild(span);
    });
  });
})();

// ── HERO: Stripe-style converging wave lines ──
(function() {
  var c = document.getElementById('heroCanvas');
  if (!c) return;
  var ctx = c.getContext('2d');
  var w, h, t = 0;
  function resize() { w = c.width = c.offsetWidth; h = c.height = c.offsetHeight; }
  resize();
  window.addEventListener('resize', resize);
  
  function draw() {
    t += 0.006;
    ctx.clearRect(0, 0, w, h);
    
    var colors = [
      { r: 99, g: 91, b: 255 },
      { r: 120, g: 87, b: 255 },
      { r: 139, g: 92, b: 246 },
      { r: 160, g: 100, b: 250 },
      { r: 120, g: 110, b: 255 }
    ];
    
    // Draw 30 converging lines from spread → pinch → fan
    var lineCount = 30;
    for (var i = 0; i < lineCount; i++) {
      var progress = i / lineCount;
      var col = colors[i % colors.length];
      var alpha = 0.3 + Math.sin(t + i * 0.2) * 0.1;
      
      ctx.beginPath();
      ctx.strokeStyle = 'rgba(' + col.r + ',' + col.g + ',' + col.b + ',' + alpha + ')';
      ctx.lineWidth = 1.5;
      
      var startY = h * 0.62 + progress * h * 0.15;
      var spread = 50 * (1 - progress * 0.3);
      
      for (var x = 0; x <= w; x += 3) {
        var xn = x / w;
        var pinch = Math.sin(xn * Math.PI);
        var focal = 1 - Math.pow(Math.abs(xn - 0.5) * 2, 2);
        var wave1 = Math.sin(xn * 4 + t + i * 0.25) * spread * 0.15;
        var wave2 = Math.sin(xn * 7 - t * 0.8 + i * 0.15) * spread * 0.08;
        var converge = (startY - h * 0.5) * (1 - focal * 0.8);
        var y = h * 0.5 + converge + (wave1 + wave2) * pinch;
        
        if (x === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
    
    // Radial glow at focal point
    var grd = ctx.createRadialGradient(w * 0.5, h * 0.5, 0, w * 0.5, h * 0.5, 200);
    grd.addColorStop(0, 'rgba(99,91,255,' + (0.12 + Math.sin(t * 2) * 0.04) + ')');
    grd.addColorStop(1, 'transparent');
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, w, h);
    
    requestAnimationFrame(draw);
  }
  draw();
})();

// ── NETWORK ECOSYSTEM DIAGRAM (Stripe integration map style) ──
(function() {
  var c = document.getElementById('networkCanvas');
  if (!c) return;
  var ctx = c.getContext('2d');
  var w, h, t = 0;
  
  function resize() {
    var rect = c.parentElement.getBoundingClientRect();
    w = c.width = rect.width;
    h = c.height = w < 768 ? 520 : 500;
  }
  resize();
  window.addEventListener('resize', resize);

  var mobileNodes = [
    { label: 'SEO', row: 0, col: 0 },
    { label: 'Google Ads', row: 0, col: 1 },
    { label: 'Meta Ads', row: 1, col: 0 },
    { label: 'TikTok Ads', row: 1, col: 1 },
    { label: 'Email & SMS', row: 2, col: 0 },
    { label: 'Analytics', row: 2, col: 1 },
    { label: 'CRO', row: 3, col: 0.5 },
    { label: 'Scaleify', row: 4, col: 0.5, isCenter: true },
    { label: 'UGC Content', row: 5, col: 0 },
    { label: 'Landing Pages', row: 5, col: 1 },
    { label: 'Growth Reports', row: 6, col: 0.5 },
  ];

  var desktopNodes = [
    { label: 'SEO', row: 0, col: 0 },
    { label: 'Google Ads', row: 0, col: 1 },
    { label: 'Meta Ads', row: 0, col: 2 },
    { label: 'TikTok Ads', row: 0, col: 3 },
    { label: 'Email & SMS', row: 0, col: 4 },
    { label: 'Analytics', row: 1, col: 1 },
    { label: 'CRO', row: 1, col: 3 },
    { label: 'Scaleify', row: 2, col: 2, isCenter: true },
    { label: 'UGC Content', row: 3, col: 0.5 },
    { label: 'Landing Pages', row: 3, col: 2 },
    { label: 'Growth Reports', row: 3, col: 3.5 },
  ];

  function isMobile() { return w < 768; }
  function getNodes() { return isMobile() ? mobileNodes : desktopNodes; }

  function getPos(node) {
    if (isMobile()) {
      var cols = 2;
      var px = (node.col + 0.5) / cols * (w - 60) + 30;
      var rows = 7;
      var py = (node.row + 0.5) / rows * (h - 60) + 30;
      return { x: px, y: py };
    }
    var cols = 5;
    var px = (node.col + 0.5) / cols * (w - 120) + 60;
    var rows = 4;
    var py = (node.row + 0.5) / rows * (h - 80) + 40;
    return { x: px, y: py };
  }
  
  function getConnections() {
    var nodes = getNodes();
    var conns = [];
    nodes.forEach(function(n, i) {
      if (i !== 7) conns.push([i, 7]);
    });
    if (isMobile()) {
      conns.push([0, 5], [1, 5], [2, 6], [3, 6], [4, 5]);
      conns.push([5, 8], [6, 9], [6, 8], [5, 10]);
    } else {
      conns.push([0, 5], [1, 5], [2, 5], [2, 6], [3, 6], [4, 6]);
      conns.push([5, 8], [5, 9], [6, 9], [6, 10]);
    }
    return conns;
  }
  
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  function draw() {
    t += 0.01;
    ctx.clearRect(0, 0, w, h);
    
    // Dot grid background
    ctx.fillStyle = 'rgba(255,255,255,0.02)';
    for (var x = 0; x < w; x += 32) {
      for (var y = 0; y < h; y += 32) {
        ctx.beginPath();
        ctx.arc(x, y, 1, 0, Math.PI * 2);
        ctx.fill();
      }
    }
    
    // Draw connections (dashed lines)
    var nodes = getNodes();
    var connections = getConnections();
    connections.forEach(function(conn) {
      var a = conn[0], b = conn[1];
      var pa = getPos(nodes[a]);
      var pb = getPos(nodes[b]);
      ctx.beginPath();
      ctx.setLineDash([4, 6]);
      var alpha = 0.15 + Math.sin(t * 2 + a + b) * 0.05;
      ctx.strokeStyle = 'rgba(99,91,255,' + alpha + ')';
      ctx.lineWidth = 1;
      ctx.moveTo(pa.x, pa.y);
      // Curved connection
      var mx = (pa.x + pb.x) / 2;
      var my = (pa.y + pb.y) / 2 + (pa.y < pb.y ? 15 : -15);
      ctx.quadraticCurveTo(mx, my, pb.x, pb.y);
      ctx.stroke();
      ctx.setLineDash([]);
      
      // Animated dot traveling along connection
      var dotT = (t * 0.5 + a * 0.3 + b * 0.2) % 1;
      var dx = pa.x + (pb.x - pa.x) * dotT;
      var dy = pa.y + (pb.y - pa.y) * dotT;
      ctx.beginPath();
      ctx.arc(dx, dy, 2, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(99,91,255,' + (0.5 + Math.sin(t * 3 + a) * 0.3) + ')';
      ctx.fill();
    });
    
    // Draw nodes
    nodes.forEach(function(node, i) {
      var pos = getPos(node);
      var isCenter = node.isCenter;
      
      if (isCenter) {
        // Glow
        var glowR = isMobile() ? 40 : 60;
        var grd = ctx.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, glowR);
        grd.addColorStop(0, 'rgba(99,91,255,0.2)');
        grd.addColorStop(1, 'transparent');
        ctx.fillStyle = grd;
        ctx.fillRect(pos.x - glowR, pos.y - glowR, glowR * 2, glowR * 2);
        
        // Box
        var bw = isMobile() ? 90 : 120, bh = isMobile() ? 34 : 44;
        ctx.fillStyle = 'rgba(99,91,255,0.9)';
        roundRect(ctx, pos.x - bw/2, pos.y - bh/2, bw, bh, 10);
        ctx.fill();
        ctx.fillStyle = '#fff';
        ctx.font = isMobile() ? 'bold 12px Inter, sans-serif' : 'bold 15px Inter, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(node.label, pos.x, pos.y);
      } else {
        // Pill node
        var fontSize = isMobile() ? 10 : 13;
        ctx.font = fontSize + 'px Inter, sans-serif';
        var tw2 = ctx.measureText(node.label).width;
        var bw2 = Math.max(tw2 + (isMobile() ? 20 : 32), isMobile() ? 60 : 90), bh = isMobile() ? 28 : 36;
        
        ctx.fillStyle = 'rgba(99,91,255,0.15)';
        ctx.strokeStyle = 'rgba(99,91,255,0.4)';
        ctx.lineWidth = 1;
        roundRect(ctx, pos.x - bw2/2, pos.y - bh/2, bw2, bh, 8);
        ctx.fill();
        ctx.stroke();
        
        ctx.fillStyle = 'rgba(255,255,255,0.85)';
        ctx.font = (isMobile() ? 10 : 13) + 'px Inter, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(node.label, pos.x, pos.y);
      }
    });
    
    requestAnimationFrame(draw);
  }
  
  draw();
})();

// ── PARTICLE GLOBE (Stripe world map style) ──
(function() {
  var c = document.getElementById('particleGlobe');
  if (!c) return;
  var ctx = c.getContext('2d');
  var w, h, t = 0;
  var particles = [];
  var numParticles = w < 600 ? 300 : 800;
  
  function resize() {
    var rect = c.parentElement.getBoundingClientRect();
    w = c.width = rect.width;
    h = c.height = rect.height || rect.width;
  }
  resize();
  window.addEventListener('resize', resize);
  
  // Generate sphere particles
  for (var i = 0; i < numParticles; i++) {
    var theta = Math.random() * Math.PI * 2;
    var phi = Math.acos(2 * Math.random() - 1);
    var r = 0.35 + Math.random() * 0.05;
    particles.push({
      theta: theta, phi: phi, r: r,
      size: 1 + Math.random() * 2,
      color: Math.random() > 0.5 ? 
        { r: 99 + Math.random() * 100, g: 91, b: 255, a: 0.3 + Math.random() * 0.5 } :
        Math.random() > 0.5 ?
        { r: 255, g: 107 + Math.random() * 50, b: 157, a: 0.2 + Math.random() * 0.4 } :
        { r: 0, g: 180 + Math.random() * 75, b: 255, a: 0.2 + Math.random() * 0.3 }
    });
  }
  
  function draw() {
    t += 0.003;
    ctx.clearRect(0, 0, w, h);
    
    var cx = w / 2;
    var cy = h / 2;
    var radius = Math.min(w, h) * 0.4;
    
    // Sort particles by z for depth
    var projected = particles.map(function(p) {
      var x3d = p.r * Math.sin(p.phi) * Math.cos(p.theta + t);
      var y3d = p.r * Math.sin(p.phi) * Math.sin(p.theta + t);
      var z3d = p.r * Math.cos(p.phi);
      var scale = 1 / (1 - z3d * 0.3);
      return {
        x: cx + x3d * radius * scale,
        y: cy + y3d * radius * scale,
        z: z3d,
        size: p.size * scale,
        color: p.color
      };
    });
    
    projected.sort(function(a, b) { return a.z - b.z; });
    
    projected.forEach(function(p) {
      var depthAlpha = (p.z + 0.5) * 0.8 + 0.2;
      var alpha = p.color.a * Math.max(0.1, depthAlpha);
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + Math.floor(p.color.r) + ',' + Math.floor(p.color.g) + ',' + Math.floor(p.color.b) + ',' + alpha + ')';
      ctx.fill();
    });
    
    // Subtle connecting lines between close particles
    for (var i = 0; i < projected.length; i += 8) {
      for (var j = i + 1; j < Math.min(i + 12, projected.length); j += 3) {
        var dx = projected[i].x - projected[j].x;
        var dy = projected[i].y - projected[j].y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 40) {
          ctx.beginPath();
          ctx.moveTo(projected[i].x, projected[i].y);
          ctx.lineTo(projected[j].x, projected[j].y);
          ctx.strokeStyle = 'rgba(99,91,255,' + (0.05 * (1 - dist / 40)) + ')';
          ctx.lineWidth = 0.5;
          ctx.stroke();
        }
      }
    }
    
    requestAnimationFrame(draw);
  }
  draw();
})();

// ── BAR CHARTS (Stripe billing dashboard style) — with scroll-triggered animation ──
(function() {
  function createBars(containerId, color1, color2, trend) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var numBars = 24;
    var targetHeights = [];
    for (var i = 0; i < numBars; i++) {
      var bar = document.createElement('div');
      bar.className = 'bar';
      var t = i / numBars;
      var h;
      if (trend === 'up') {
        // Steeper uptrend — starts low, ends high with clear growth curve
        h = 10 + Math.pow(t, 1.5) * 80 + (Math.random() * 10);
      } else {
        h = 15 + Math.random() * 85;
      }
      h = Math.min(h, 100);
      // Start at 0 height for animation
      bar.style.height = '0%';
      bar.style.background = 'linear-gradient(180deg, ' + color1 + ', ' + color2 + ')';
      bar.style.opacity = 0.6 + t * 0.4;
      bar.style.transition = 'height 1.2s cubic-bezier(0.4, 0, 0.2, 1) ' + (i * 40) + 'ms';
      container.appendChild(bar);
      targetHeights.push(h);
    }
    // Animate on scroll into view
    var animated = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          var bars = container.querySelectorAll('.bar');
          bars.forEach(function(bar, idx) {
            bar.style.height = targetHeights[idx] + '%';
          });
          observer.unobserve(container);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(container);
  }
  createBars('barChart', '#635bff', '#8b5cf6', 'up');

  // Animate progress bars on scroll too
  document.querySelectorAll('.progress-bar .fill').forEach(function(fill) {
    var targetWidth = fill.style.width;
    fill.style.width = '0%';
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          fill.style.width = targetWidth;
          observer.unobserve(fill.parentElement);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(fill.parentElement);
  });
})();

// ── WHITE GLOBE (reference-matched: continental dots, arc lines, slow rotation) ──
(function() {
  var c = document.getElementById('globeCanvas');
  if (!c) return;
  var ctx = c.getContext('2d');
  var w, h, rotation = 2.5; // Europe/Africa/Asia view
  var DPR = window.devicePixelRatio || 1;

  function resize() {
    var rect = c.parentElement.getBoundingClientRect();
    w = rect.width;
    h = rect.height || rect.width;
    c.width = w * DPR;
    c.height = h * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  // Simplified continent data: [lat, lon] clusters with organic sub-regions
  var continents = [
    // North America
    { latRange: [48, 70], lonRange: [-140, -60], density: 0.6 },
    { latRange: [25, 50], lonRange: [-125, -65], density: 0.7 },
    { latRange: [30, 48], lonRange: [-105, -75], density: 0.8 },
    { latRange: [55, 70], lonRange: [-130, -90], density: 0.4 },
    // Central America
    { latRange: [8, 25], lonRange: [-105, -80], density: 0.5 },
    { latRange: [15, 22], lonRange: [-90, -82], density: 0.6 },
    // South America
    { latRange: [-10, 10], lonRange: [-80, -50], density: 0.6 },
    { latRange: [-25, -5], lonRange: [-65, -35], density: 0.7 },
    { latRange: [-40, -20], lonRange: [-70, -55], density: 0.5 },
    { latRange: [-55, -40], lonRange: [-75, -65], density: 0.3 },
    // Europe
    { latRange: [36, 44], lonRange: [-10, 3], density: 0.8 },
    { latRange: [42, 51], lonRange: [-5, 8], density: 0.9 },
    { latRange: [47, 55], lonRange: [5, 15], density: 0.9 },
    { latRange: [36, 45], lonRange: [7, 20], density: 0.8 },
    { latRange: [45, 55], lonRange: [14, 25], density: 0.7 },
    { latRange: [50, 60], lonRange: [-10, 2], density: 0.9 },
    { latRange: [55, 70], lonRange: [5, 30], density: 0.5 },
    { latRange: [50, 60], lonRange: [25, 42], density: 0.6 },
    // Africa
    { latRange: [20, 35], lonRange: [-18, 10], density: 0.5 },
    { latRange: [22, 32], lonRange: [10, 35], density: 0.4 },
    { latRange: [0, 20], lonRange: [-18, 15], density: 0.6 },
    { latRange: [-5, 12], lonRange: [8, 30], density: 0.5 },
    { latRange: [-10, 5], lonRange: [28, 42], density: 0.6 },
    { latRange: [-35, -10], lonRange: [20, 40], density: 0.5 },
    { latRange: [-20, 0], lonRange: [42, 50], density: 0.4 },
    // Middle East
    { latRange: [12, 35], lonRange: [35, 55], density: 0.5 },
    { latRange: [30, 42], lonRange: [40, 50], density: 0.6 },
    // Asia
    { latRange: [20, 45], lonRange: [70, 100], density: 0.5 },
    { latRange: [30, 55], lonRange: [100, 125], density: 0.6 },
    { latRange: [45, 65], lonRange: [60, 140], density: 0.3 },
    { latRange: [8, 25], lonRange: [68, 90], density: 0.7 },
    // Southeast Asia
    { latRange: [0, 20], lonRange: [95, 120], density: 0.5 },
    { latRange: [-8, 5], lonRange: [100, 140], density: 0.4 },
    // Japan / Korea
    { latRange: [30, 45], lonRange: [125, 145], density: 0.8 },
    // Australia
    { latRange: [-38, -12], lonRange: [115, 150], density: 0.5 },
    { latRange: [-28, -18], lonRange: [130, 148], density: 0.6 },
    // New Zealand
    { latRange: [-47, -34], lonRange: [166, 178], density: 0.6 }
  ];

  // Generate 12000 dense dots on continents — pointillist style
  var dots = [];
  var numDots = 12000;
  for (var i = 0; i < numDots; i++) {
    var cont = continents[Math.floor(Math.random() * continents.length)];
    if (Math.random() > cont.density) { i--; continue; }
    var lat = cont.latRange[0] + Math.random() * (cont.latRange[1] - cont.latRange[0]);
    var lon = cont.lonRange[0] + Math.random() * (cont.lonRange[1] - cont.lonRange[0]);
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (lon + 180) * Math.PI / 180;
    dots.push({ phi: phi, theta: theta, size: 0.3 + Math.random() * 0.8, lat: lat, lon: lon });
  }

  // Ocean dots — denser to define sphere shape, especially southern hemisphere
  for (var i = 0; i < 800; i++) {
    var lat = -80 + Math.random() * 160;
    var lon = -180 + Math.random() * 360;
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (lon + 180) * Math.PI / 180;
    dots.push({ phi: phi, theta: theta, size: 0.15 + Math.random() * 0.35, lat: lat, lon: lon });
  }
  // Extra southern hemisphere dots to fill out the sphere bottom
  for (var i = 0; i < 300; i++) {
    var lat = -75 + Math.random() * 45;
    var lon = -180 + Math.random() * 360;
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (lon + 180) * Math.PI / 180;
    dots.push({ phi: phi, theta: theta, size: 0.12 + Math.random() * 0.25, lat: lat, lon: lon });
  }

  // Arc connections between cities
  var cityPairs = [
    [40.7, -74, 51.5, 0],
    [51.5, 0, 35.7, 139.7],
    [34, -118, -33.9, 151.2],
    [1.3, 103.8, 48.9, 2.3],
    [55.8, 37.6, 39.9, 116.4],
    [-23.5, -46.6, 25, 55],
    [37.6, -122.4, 22.3, 114.2],
    [48.9, 2.3, 28.6, 77.2]
  ];

  var arcs = cityPairs.map(function(pair) {
    return {
      phi1: (90 - pair[0]) * Math.PI / 180,
      theta1: (pair[1] + 180) * Math.PI / 180,
      phi2: (90 - pair[2]) * Math.PI / 180,
      theta2: (pair[3] + 180) * Math.PI / 180,
      progress: Math.random(),
      speed: 0.002 + Math.random() * 0.003
    };
  });

  // Color function: vivid gradient
  function dotColor(screenX, cx2, z) {
    var t2 = Math.max(0, Math.min(1, screenX / (cx2 * 2)));
    var depth = Math.max(0, (z + 1) / 2);
    var r, g, b;
    if (t2 < 0.25) {
      var u = t2 / 0.25;
      r = 80 + u * 60; g = 50 + u * 20; b = 200 + u * 55;
    } else if (t2 < 0.45) {
      var u = (t2 - 0.25) / 0.2;
      r = 140 + u * 60; g = 70 - u * 30; b = 255 - u * 20;
    } else if (t2 < 0.65) {
      var u = (t2 - 0.45) / 0.2;
      r = 200 + u * 40; g = 40 + u * 50; b = 235 - u * 60;
    } else {
      var u = (t2 - 0.65) / 0.35;
      r = 240 + u * 15; g = 90 + u * 30; b = 175 - u * 120;
    }
    return { r: Math.min(255, r), g: Math.max(0, g), b: Math.max(0, b), a: 0.5 + depth * 0.5 };
  }

  // 3D projection
  function project(phi2, theta2, cx2, cy2, radius, rot) {
    var x3d = Math.sin(phi2) * Math.cos(theta2 + rot);
    var y3d = Math.cos(phi2);
    var z3d = Math.sin(phi2) * Math.sin(theta2 + rot);
    return { x: cx2 + x3d * radius, y: cy2 - y3d * radius, z: z3d };
  }

  function draw() {
    rotation += 0.002;
    ctx.clearRect(0, 0, w, h);

    var radius = Math.min(w, h) * 0.44;
    var cx2 = w * 0.5;
    var cy2 = h * 0.48;

    // Project and sort dots by depth
    var projected = [];
    for (var i = 0; i < dots.length; i++) {
      var d = dots[i];
      var p = project(d.phi, d.theta, cx2, cy2, radius, rotation);
      if (p.z > -0.2) {
        projected.push({ x: p.x, y: p.y, z: p.z, size: d.size, lat: d.lat, lon: d.lon });
      }
    }
    projected.sort(function(a, b) { return a.z - b.z; });

    // Draw dots — clean pointillist style
    for (var i = 0; i < projected.length; i++) {
      var p = projected[i];
      var col = dotColor(p.x, cx2, p.z);
      var depthFactor = Math.max(0, (p.z + 0.05) / 1.05);
      var alpha = col.a * depthFactor;
      var dotSize = p.size * (0.5 + depthFactor * 0.5);
      ctx.beginPath();
      ctx.arc(p.x, p.y, dotSize, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + Math.floor(col.r) + ',' + Math.floor(col.g) + ',' + Math.floor(col.b) + ',' + alpha.toFixed(3) + ')';
      ctx.fill();
    }

    // Arc connections with flowing pulses — enhanced visibility
    for (var i = 0; i < arcs.length; i++) {
      var arc = arcs[i];
      arc.progress += arc.speed;
      if (arc.progress > 1.5) arc.progress = -0.5;

      var p1 = project(arc.phi1, arc.theta1, cx2, cy2, radius, rotation);
      var p2 = project(arc.phi2, arc.theta2, cx2, cy2, radius, rotation);
      if (p1.z < -0.3 && p2.z < -0.3) continue;

      var midX = (p1.x + p2.x) / 2;
      var midY = (p1.y + p2.y) / 2;
      var dist = Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
      var arcHeight = dist * 0.4;
      var ctrlX = midX;
      var ctrlY = midY - arcHeight;

      var avgZ = (p1.z + p2.z) / 2;
      var arcAlpha = Math.max(0, Math.min(0.6, 0.45 * (avgZ + 1)));

      // Outer glow arc line
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.quadraticCurveTo(ctrlX, ctrlY, p2.x, p2.y);
      ctx.strokeStyle = 'rgba(180,100,255,' + (arcAlpha * 0.25).toFixed(3) + ')';
      ctx.lineWidth = 3;
      ctx.stroke();

      // Main arc line
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.quadraticCurveTo(ctrlX, ctrlY, p2.x, p2.y);
      ctx.strokeStyle = 'rgba(255,130,220,' + (arcAlpha * 0.7).toFixed(3) + ')';
      ctx.lineWidth = 1.2;
      ctx.stroke();

      // Bright core arc line
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.quadraticCurveTo(ctrlX, ctrlY, p2.x, p2.y);
      ctx.strokeStyle = 'rgba(255,200,255,' + (arcAlpha * 0.4).toFixed(3) + ')';
      ctx.lineWidth = 0.5;
      ctx.stroke();

      // Flowing pulse dot
      var prog = Math.max(0, Math.min(1, arc.progress));
      if (prog > 0 && prog < 1) {
        var t2 = prog;
        var px = (1-t2)*(1-t2)*p1.x + 2*(1-t2)*t2*ctrlX + t2*t2*p2.x;
        var py = (1-t2)*(1-t2)*p1.y + 2*(1-t2)*t2*ctrlY + t2*t2*p2.y;
        var pulseAlpha = Math.max(0, arcAlpha * 2.5 * Math.sin(t2 * Math.PI));

        // Wide outer glow
        ctx.beginPath();
        ctx.arc(px, py, 12, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(180,100,255,' + (pulseAlpha * 0.1).toFixed(3) + ')';
        ctx.fill();
        // Mid glow
        ctx.beginPath();
        ctx.arc(px, py, 6, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,150,220,' + (pulseAlpha * 0.35).toFixed(3) + ')';
        ctx.fill();
        // Inner bright
        ctx.beginPath();
        ctx.arc(px, py, 3, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,220,255,' + (pulseAlpha * 0.8).toFixed(3) + ')';
        ctx.fill();
        // Core white
        ctx.beginPath();
        ctx.arc(px, py, 1.5, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,' + pulseAlpha.toFixed(3) + ')';
        ctx.fill();
      }

      // City endpoint dots with enhanced glow
      [p1, p2].forEach(function(ep) {
        if (ep.z > -0.15) {
          var epAlpha = Math.max(0, (ep.z + 0.15) / 1.15);
          // Outer halo
          ctx.beginPath();
          ctx.arc(ep.x, ep.y, 6, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(180,100,255,' + (epAlpha * 0.15).toFixed(3) + ')';
          ctx.fill();
          // Inner glow
          ctx.beginPath();
          ctx.arc(ep.x, ep.y, 3, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255,150,220,' + (epAlpha * 0.5).toFixed(3) + ')';
          ctx.fill();
          // Core dot
          ctx.beginPath();
          ctx.arc(ep.x, ep.y, 1.5, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255,230,255,' + (epAlpha * 0.9).toFixed(3) + ')';
          ctx.fill();
        }
      });
    }

    requestAnimationFrame(draw);
  }
  draw();
})();

// ── TAB PILL INTERACTION ──
document.querySelectorAll('.tab-pill').forEach(function(pill) {
  pill.addEventListener('click', function() {
    document.querySelectorAll('.tab-pill').forEach(function(p) { p.classList.remove('active'); });
    pill.classList.add('active');
  });
});
